import script from "./MysticMark.vue?vue&type=script&setup=true&lang=js"
export * from "./MysticMark.vue?vue&type=script&setup=true&lang=js"

import "./MysticMark.vue?vue&type=style&index=0&id=53aa35d2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53aa35d2"]])

export default __exports__